import { Box } from '@/components'

export function NoResult({ hasRadius }: { hasRadius?: boolean }) {
  return (
    <Box className='mt-6 font-normal'>
      <div className='mx-auto text-center text-base/8 font-normal'>
        No vehicles matched your search criteria!<br />
        {hasRadius && <>Please try increasing the search radius.</>}
      </div>
    </Box>
  )
}